import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

// Pill-shaped primary button (orange) and variants used across the portal.
const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-200 min-h-[44px] px-6 text-base focus-visible:outline-none disabled:opacity-50 disabled:cursor-not-allowed select-none";

const variants = {
  primary: "bg-brand-orange text-white hover:bg-brand-orange-dark active:scale-[0.98] pib-shadow-sm",
  secondary: "bg-brand-navy text-white hover:bg-brand-navy-soft active:scale-[0.98]",
  outline: "bg-white text-brand-navy border-2 border-brand-navy/15 hover:border-brand-orange hover:text-brand-orange",
  ghost: "bg-transparent text-brand-navy hover:bg-brand-cream",
  cream: "bg-brand-cream text-brand-navy hover:bg-brand-cream-dark",
};

export function Button({ variant = "primary", className, children, ...props }) {
  return (
    <button className={cn(base, variants[variant], className)} {...props}>
      {children}
    </button>
  );
}

export function ButtonLink({ to, href, variant = "primary", className, children, ...props }) {
  const cls = cn(base, variants[variant], className);
  if (href) {
    return (
      <a href={href} className={cls} {...props}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} className={cls} {...props}>
      {children}
    </Link>
  );
}

export function Card({ className, children, ...props }) {
  return (
    <div
      className={cn("rounded-2xl bg-white border border-brand-navy/10 pib-shadow", className)}
      {...props}
    >
      {children}
    </div>
  );
}

export function Pill({ className, children }) {
  return (
    <span className={cn("inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold", className)}>
      {children}
    </span>
  );
}

export function SectionTitle({ children, className }) {
  return (
    <h2 className={cn("display-title text-brand-navy text-2xl sm:text-3xl", className)}>{children}</h2>
  );
}
